// Garder aligné avec jemos-back/utils/validation.js (ADR 0007).
// Utilisé pour définir un nouveau mot de passe, jamais pour la connexion.
export const getNewPasswordError = (value) => {
  if (typeof value !== "string" || value.length < 8) return "registrationPasswordRequirements";
  // Blob mesure les octets UTF-8, comme bcrypt côté serveur.
  if (new Blob([value]).size > 72) return "passwordTooLong";
  const categories = [/\p{Ll}/u, /\p{Lu}/u, /\p{Nd}/u, /[\p{P}\p{S}\p{Zs}]/u];
  return categories.filter((category) => category.test(value)).length >= 3
    ? null
    : "registrationPasswordRequirements";
};

export const isValidNewPassword = (value) => getNewPasswordError(value) === null;
